import _get from "lodash/get";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import * as FWA_SELECTORS from "./selectors";
import { RootState } from "../../../../models";
import { ServerFwaCart } from "../../../../models/server";
import { AddressSelected, StreetNumber } from "../../../../models/state";
import { get as Ajax_get, post as Ajax_post, put as Ajax_put } from "../../app/Ajax";
import { VALIDATION_FIELD } from "../../rapidform/formValidation";
import {
    API_URL_ADDRESS_SEARCH,
    API_URL_ADDRESS_STREET,
    API_URL_LOOKUP_PACKAGES,
    API_URL_CHECK_AND_SAVE_ADDRESS,
    API_URL_ADD_PACKAGE,
    API_URL_SAVE_CONTACT_INFO,
    API_URL_SUBMIT,
} from "../api";

export const setSelectedField = (field: string, value: string | number) => ({
    type: AT.FWA_SET_SELECTED_FIELD,
    field,
    value,
});

export const setField = (field: string, value: string | number) => ({
    type: AT.FWA_UPDATE_FIELD,
    field,
    value,
});

export const lookupStreetNames = (zipCode: string) => ({
    type: AT.FWA_LOOKUP_STREET,
    payload: Ajax_get({
        url: API_URL_ADDRESS_STREET(zipCode),
    }),
});

export const saveAndCheckVaid =
    (address: AddressSelected): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.FWA_CHECK_ADDRESS,
            payload: Ajax_post({
                url: API_URL_CHECK_AND_SAVE_ADDRESS,
                data: { address },
            }).then(() => ({
                success: true,
            })),
        });
    };

export const lookupStreetNumbers = (zipCode: string, streetName: string) => ({
    type: AT.FWA_SEARCH_ADDRESS,
    payload: Ajax_get<{ data: StreetNumber[] }>({
        url: API_URL_ADDRESS_SEARCH(zipCode, streetName),
    }).then((data) => {
        const streetNumbers = _get(data, "data") || data || [];
        return streetNumbers.map((item: StreetNumber) => ({
            ...item,
            streetNumber: item.streetNumber + (item.streetLetter ?? "") + "",
        }));
    }),
});

export const lookupPackages = () => ({
    type: AT.FWA_LOOKUP_PACKAGES,
    payload: Ajax_get({
        url: API_URL_LOOKUP_PACKAGES,
    }),
});

export const addBroadbandPackageToCart =
    (product: { additionalProducts: number[]; id: number }): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.FWA_ADD_PACKAGE_TO_CART,
            payload: Ajax_put<{ order: ServerFwaCart }>({
                url: API_URL_ADD_PACKAGE,
                data: { product },
            }).then((res) => ({
                packageId: res.order.packageId,
                contentfulPackageId: res.order.contentfulPackageId,
                additionalProducts: res.order.additionalProducts,
                success: true,
            })),
        });
    };

export const submit = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) => {
    return dispatch({
        type: AT.FWA_UPDATE_CUSTOMER_AND_SUBMIT,
        payload: Ajax_post<{ orderId: string; orderRef: string }>(
            {
                url: API_URL_SUBMIT,
                data: {},
            },
            dispatch,
        ).then((res) => {
            return {
                orderId: res.orderId,
                orderRef: res.orderRef,
                success: true,
            };
        }),
    });
};

export const setCustomAddressChecked = (checked: boolean) => ({
    type: AT.FWA_SET_CUSTOM_ADDRESS_CHECKED,
    value: !!checked,
});

export const saveContactInfo =
    (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async (dispatch, getState) => {
        const state = getState();
        const { values } = FWA_SELECTORS.getFormById(state, "personalDetailsFwaForm");

        const personalDetails = {
            email: values.details[VALIDATION_FIELD.PRODUCT_USER_EMAIL],
            phone: values.details[VALIDATION_FIELD.PRODUCT_USER_PHONE],
        };

        const isCustomAddressSelected = FWA_SELECTORS.isCustomAddressSelected(state);
        let shippingDetails = null;

        if (isCustomAddressSelected) {
            shippingDetails = {
                street: values.details[VALIDATION_FIELD.STREET],
                zipCode: values.details[VALIDATION_FIELD.POSTCODE],
                city: values.details[VALIDATION_FIELD.CITY],
            };
        }

        await Ajax_post({
            url: API_URL_SAVE_CONTACT_INFO,
            data: { personalDetails, shippingDetails },
        });
    };
